/* eslint-disable camelcase -- Existing Firestore field names. */
import { timestampMillis } from './league-offer-week';

// An allowlist, not a blacklist: newly added account fields stay private by default.
export const PUBLIC_USER_FIELDS = [
  'id', 'ad', 'soyad', 'foto_url', 'foto_mini_url', 'cinsiyet',
  'null_raket_marka', 'null_forehand', 'null_seviye', 'verified_account',
  'arama_motoru_gorunur_mu', 'buhaftamusait_mi', 'lig_temel_id', 'lig_cift_takim_id',
  'puan', 'galibiyet', 'maglubiyet', 'piramit_sira', 'piramit_puan',
  'piramit_etken_puan', 'piramit_sira_gecmis', 'log_toplam_mac',
  'log_toplam_glb', 'log_toplam_mlb', 'followers_count', 'following_count',
] as const;

// Keep the legacy UI model at the boundary; private account consumers must use
// authenticated readers instead. Never spread the source document into props.
export function toPublicUser(user: Users.User): Users.User {
  const result: Record<string, unknown> = {};
  PUBLIC_USER_FIELDS.forEach(field => {
    const value = user[field];
    if (value !== undefined) result[field] = value;
  });
  return result as unknown as Users.User;
}

/**
 * Oyna ve maç detayı için oyuncu: kamusal alanlar + teklif kuralının gösterdiği ceza bitişi (ms).
 * İstemci başka oyuncunun profil belgesini okuyamaz (LG-12); bu görünüm `/api/players`'tan gelir.
 */
export function toPlayPlayer(user: Users.User): Users.User {
  const until = timestampMillis((user as { mac_cezasi_bitis?: unknown }).mac_cezasi_bitis);
  return { ...toPublicUser(user), ...(Number.isFinite(until) ? { mac_cezasi_bitis: until } : {}) } as Users.User;
}

export function canViewPlayerContact(viewer: Users.User | null, player: Users.User | null): boolean {
  return Boolean(viewer?.id && player?.id && (
    viewer.id === player.id || (viewer.lig_temel_id && viewer.lig_temel_id === player.lig_temel_id)
  ));
}
